export default __webpack_public_path__ + "static/media/fasad2.ee0071cb.jpeg";